import { put, call, takeLatest } from 'redux-saga/effects';
import * as api from './Api';
import { actions } from './Reducer';
import {
  setMyArtisanPublicInquiryIsLoading,
  // getArtisanPublicInquirySuccessAction,
  getMyArtisanPublicInquirySuccessAction,
  getMyArtisanPublicInquiriesSuccessAction,
  getMyPublicArtisanProposalsSuccessAction,
  addMyPublicArtisanProposalSuccessActon,
  editMyPublicArtisanProposalSuccessAction,
  getMyPublicArtisanProposalSuccessAction,
  deleteMyPublicArtisanProposalSuccessAction,
  setMyArtisanPublicInquiriesCountAction,
  filterMyArtisanPublicInquiriesSuccessAction,
} from './Actions';

import {
  errorNotificationFromError,
  newSuccessNotificationAction,
} from '../../../notifications/Actions';

import { push } from 'react-router-redux';

const body = {
  offset: 0,
  size: 10,
  searchTerm: '',
  filterBy: [{ moderated: false }], // for testing only value === true
  sort: 'createdAt',
  dir: 'asc',
};

function* getMyArtisanPublicInquiries({ payload }) {
  const defBody = {
    ...body,
    ...payload,
  };
  try {
    yield put(setMyArtisanPublicInquiryIsLoading(true));
    const response = yield call(api.getMyArtisanPublicInquiries, defBody);
    const { data } = response;
    const { content, count } = data;
    console.log(content);
    yield put(getMyArtisanPublicInquiriesSuccessAction(content));
    yield put(setMyArtisanPublicInquiriesCountAction(count));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMyArtisanPublicInquiryIsLoading(false));
  }
}

function* filterMyArtisanPublicInquiries({ payload }) {
  const defBody = {
    ...body,
    ...payload,
  };
  try {
    yield put(setMyArtisanPublicInquiryIsLoading(true));
    const response = yield call(api.getMyArtisanPublicInquiries, defBody);
    const { data } = response;
    const { content, count } = data;
    console.log(content);
    yield put(filterMyArtisanPublicInquiriesSuccessAction(content));
    // yield put(setMyArtisanPublicInquiriesCountAction(count))
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMyArtisanPublicInquiryIsLoading(false));
  }
}

function* getArtisanPublicInquiry({ payload }) {
  const inquireyId = payload;
  const body = {
    inquiryID: inquireyId,
  };
console.log(payload, 'payload')
  try {
    yield put(setMyArtisanPublicInquiryIsLoading(true));
    const response = yield call(api.getMyArtisanPublicInquiry, body);
    const { data } = response;

    console.log(data);
    yield put(getMyArtisanPublicInquirySuccessAction(data));
    yield put(newSuccessNotificationAction('Get Public Inquiry'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMyArtisanPublicInquiryIsLoading(false));
  }
}

function* getArtisanPublicProposals({ payload }) {
  const defBody = {
    ...body,
    ...payload,
  };
  try {
    yield put(setMyArtisanPublicInquiryIsLoading(true));
    const response = yield call(api.getMyArtisanPublicInquiries, defBody);
    const { data } = response;
    const { content, count } = data;
    yield put(getMyPublicArtisanProposalsSuccessAction(content));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMyArtisanPublicInquiryIsLoading(false));
  }
}

function* getArtisanPublicProposal({ payload }) {
  const inquireyId = payload;
  const inquireyBody = {
    inquiryID: inquireyId,
  };

  try {
    yield put(setMyArtisanPublicInquiryIsLoading(true));
    const response = yield call(api.getMyArtisanPublicInquiry, inquireyBody);
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMyArtisanPublicInquiryIsLoading(false));
  }
}

function* addArtisanPublicProposal({ payload, trusted }) {
  try {
    yield put(setMyArtisanPublicInquiryIsLoading(true));
    if (trusted) {
    const response = yield call(api.addArtisanPublicProposal, payload);
    const { data } = response;
    yield put(addMyPublicArtisanProposalSuccessActon(data));
    yield put(newSuccessNotificationAction('Proposal Sent!'));
    yield put(push('/my-public-inquiries-artisan/'));
    } else {
    const response = yield call(api.addArtisanPublicStagingProposal, payload);
    const { data } = response;
    // yield put(addMyPublicArtisanProposalSuccessActon(data));
    yield put(newSuccessNotificationAction('Proposal Sent! Pending'));
    yield put(push('/my-public-inquiries-artisan/'));
    }
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMyArtisanPublicInquiryIsLoading(false));
  }
}

function* editArtisanPublicProposal({ payload , trusted}) {
  try {
    yield put(setMyArtisanPublicInquiryIsLoading(true));
    if (trusted) {
    const response = yield call(api.editArtisanPublicProposal, payload);
    const { data } = response;
    yield put(editMyPublicArtisanProposalSuccessAction(data));
    
    yield put(push('/my-public-inquiries-artisan/'));
    } else {
    const response = yield call(api.editStagingArtisanPublicProposal, payload);
    const { data } = response;
    // yield put(editMyPublicArtisanProposalSuccessAction(data));
    
    yield put(push('/my-public-inquiries-artisan/'));
    }
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMyArtisanPublicInquiryIsLoading(false));
  }
}

function* deleteArtisanPublicProposal({ payload }) {
  try {
    yield put(setMyArtisanPublicInquiryIsLoading(true));
    yield call(api.deleteArtisanPublicProposal, payload);
    yield put(deleteMyPublicArtisanProposalSuccessAction(payload.inquiryId));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMyArtisanPublicInquiryIsLoading(false));
  }
}

export default function*() {
  yield takeLatest(
    actions.GET_MY_ARTISAN_PUBLIC_INQUIREY,
    getArtisanPublicInquiry
  );
  yield takeLatest(
    actions.GET_MY_ARTISAN_PUBLIC_INQUIRIES,
    getMyArtisanPublicInquiries
  );
  yield takeLatest(
    actions.ADD_PUBLIC_ARTISAN_PROPOSAL,
    addArtisanPublicProposal
  );
  yield takeLatest(
    actions.EDIT_PUBLIC_ARTISAN_PROPOSAL,
    editArtisanPublicProposal
  );
  yield takeLatest(
    actions.DELETE_PUBLIC_ARTISAN_PROPOSAL,
    deleteArtisanPublicProposal
  );
  yield takeLatest(
    actions.GET_MY_ARTISAN_PUBLIC_PROPOSALS,
    getArtisanPublicProposals
  );
  yield takeLatest(
    actions.GET_MY_ARTSAN_PUBLIC_PROPOSAL,
    getArtisanPublicProposal
  );
  yield takeLatest(
    actions.FITLER_MY_ARTISAN_PUBLIC_INQUIRIES,
    filterMyArtisanPublicInquiries
  );
}
